import React, { useState, useEffect } from 'react';
import { Phone, Mail, Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-900">
              Franck Curiotti <span className="text-blue-600">Carrelage</span>
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('accueil')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Accueil
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('gallery')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Galerie
            </button>
            <button onClick={() => scrollToSection('process')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Notre Process
            </button>
            <button onClick={() => scrollToSection('zone')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Zone d'intervention
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Contact
            </button>
          </nav>

          {/* Contact Info & CTA - REMOVED pour site statique */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:0608937844" className="flex items-center text-gray-700 hover:text-blue-600 transition-colors">
              <Phone className="w-4 h-4 mr-2" />
              <span className="font-semibold">06 08 93 78 44</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('accueil')} className="text-left text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Accueil
              </button>
              <button onClick={() => scrollToSection('services')} className="text-left text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Services
              </button>
              <button onClick={() => scrollToSection('gallery')} className="text-left text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Galerie
              </button>
              <button onClick={() => scrollToSection('process')} className="text-left text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Notre Process
              </button>
              <button onClick={() => scrollToSection('zone')} className="text-left text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Zone d'intervention
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-left text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Contact
              </button>
              <a href="tel:0608937844" className="flex items-center text-blue-600 font-semibold pt-4 border-t border-gray-200">
                <Phone className="w-4 h-4 mr-2" />
                06 08 93 78 44
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
